import * as types from '../constants/ActionTypes';

export const addSelectedViewToGroup = (index) => ({
  index,
  type: types.ADD_SELECTED_VIEW,
});

export const removeSelectedViewFromGroup = (index) => ({
  index,
  type: types.REMOVE_SELECTED_VIEW,
});

export const setViewsGroup = (group) => ({
  group,
  type: types.SET_VIEWS_GROUP,
});

export const setLayout = (layout) => ({
  layout,
  type: types.SET_LAYOUT,
});

export const addLayoutElement = (element) => ({
  element,
  type: types.ADD_LAYOUT_ELEMENT,
});

export const setLayoutElement = (index, element) => ({
  index,
  element,
  type: types.SET_LAYOUT_ELEMENT,
});

export const updateLayoutElement = (viewIndex, newProperties) => ({
  viewIndex,
  newProperties,
  type: types.UPDATE_LAYOUT_ELEMENT,
});

export const setLayoutElements = (elements) => ({
  elements,
  type: types.SET_LAYOUT_ELEMENTS,
});

export const setLayoutElementCamera = (index, initOptions) => ({
  index,
  initOptions,
  type: types.SET_LAYOUT_ELEMENT_CAMERA,
});

export const setLayoutGrid = (columns, rows) => {
  if (columns < 1) {
    // eslint-disable-next-line no-param-reassign
    columns = 1;
  }

  if (rows < 1) {
    // eslint-disable-next-line no-param-reassign
    rows = 1;
  }

  return {
    columns,
    rows,
    type: types.SET_LAYOUT_GRID,
  };
};

export const setSelectedView = (index) => ({
  index,
  type: types.CHANGE_VIEW_SELECTED,
});

export const setShowExplorer = (show) => ({
  show,
  type: types.SHOW_EXPLORER,
});

export const setShowHistory = (show) => ({
  show,
  type: types.SHOW_HISTORY,
});

export const setRefLines = () => ({
  type: types.SET_REF_LINES,
});

export const setScrollType = () => ({
  type: types.SET_SCROLL_TYPE,
});

export const setCurrentTool = (currentTool) => ({
  currentTool,
  type: types.SET_CURRENT_TOOL,
});

export const resetLayoutState = () => ({
  type: types.RESET_LAYOUT_STATE,
});

export const resetLayoutStateByElement = (element, i) => ({
  type: types.RESET_LAYOUT_ELEMENT_STATE,
});

export const setIs3DModeEnabled = (is3DModeEnabled) => ({
  is3DModeEnabled,
  type: types.SET_IS_3D_MODE_ENABLED,
});

export const setIsMPRModeEnabled = (isMPRModeEnabled) => ({
  isMPRModeEnabled,
  type: types.SET_IS_MPR_MODE_ENABLED,
});
